import { render } from "./Abandons.vue?vue&type=template&id=75c30706&scoped=true"
import script from "./Abandons.vue?vue&type=script&lang=js"
export * from "./Abandons.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=75c30706&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c30706"]])

export default __exports__